import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import InstallationPreferencesPanel from 'components/InstallationPreferences/InstallationPreferencesPanel';
import StoreInstallationPreview from './StoreInstallationPreview';

export default function OfferingSettings() {
  const { hash } = useLocation();
  const installationRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (hash === '#installation' && installationRef.current) {
      installationRef.current.scrollIntoView({ block: 'start' });
      installationRef.current.focus({ preventScroll: true });
    }
  }, [hash]);

  return <section id="installation" aria-label="Installation" tabIndex={-1} ref={installationRef}>
    <StoreInstallationPreview />
    <InstallationPreferencesPanel guided />
  </section>;
}
